const CancelWarning = (
  <>
    Esta cancelación <span>NO AFECTARÁ</span> a ninguna otra línea.{' '}
    <span>Si hay líneas adicionales o dúo, no se cancelarán automáticamente.</span> Recuerda
    cancelar estas líneas en vista (si el cliente lo desea).
  </>
)

export default CancelWarning
